// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module--card--gToke","imgWrapper":"styles-module--imgWrapper--1PzYu","title":"styles-module--title--1u-Bb","price":"styles-module--price--1X_US"};